import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { getFxEnabledRoles } from 'common/utils/user';
export const routes = [
    {
        component: lazy(() => import('module/devices/DevicesPage')),
        permissions: [
            'Device_Read',
            'Device_Create',
            'Device_Edit',
            'Device_Delete',
            'DeviceLog_Read',
            'DeviceLog_Create',
        ],
        path: '/devices/:tab',
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.AdminReadOnly,
            ...getFxEnabledRoles(),
        ],
    },
];
